module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        return _vm.abrirModal()
      }
    }
  }, [_vm._v("\n        Preventivas\n      ")]), _vm._v(" "), _c('modal-planilhas-preventivas', {
    on: {
      "selecionado": _vm.downloadAnexo
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d2112d12!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/planilha/planilhas-adm/ExportPreventivas.vue
// module id = 1023
// module chunks = 1